import { useEffect, useRef } from "react";
import React from "react";
import * as Common from '../Common'

const ConveraPayment = () => {
  const containerRef = useRef(null);
  const isConveraLive = sessionStorage.getItem('isLive');
  console.log(isConveraLive);
  let CONVERAID;
  let CONVERASECRET;
  let CONVERASRC;
  if (isConveraLive === 'true') {
    CONVERASRC = "https://paymentmodule.convera.com/static/js/main.js";
    CONVERAID = "c4cc451d6cad46aab3939093ba8631ae";
    CONVERASECRET = "e3d8a242a7b54dc5884895bcbcbb14a1";
  } else {
    CONVERASRC = "https://sandbox-uat.spm.convera.com/static/js/main.js";
    CONVERAID = "85a9f788e6d449df8f6d03648b7c2706"; // You may want to change this if there's a different sandbox ID
    CONVERASECRET = "bd41618292dc44d6a949cb7ec0f45188"; // Same here
  }

  useEffect(() => {
    const converaObj = JSON.parse(sessionStorage.getItem("converaObj"));
    if (!converaObj) {
      console.error("Convera object not found in sessionStorage");
      return;
    }
    const loadScript = () => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = CONVERASRC;
        // console.log(Common.CONVERASRC)
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    const createWidget = () => {
      let dataInput = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
        <paymentInformation>
          <clientReference>${converaObj?.refno}</clientReference>
          <clientReference1>${converaObj?.refno}</clientReference1>
          <clientReference2>${converaObj?.refno}</clientReference2>
          <clientId>${converaObj?.clientId}</clientId>
          <merchantId>${CONVERAID}</merchantId>
          <merchantSecret>${CONVERASECRET}</merchantSecret>  
          <buyerCanEdit>true</buyerCanEdit>
          <buyer>
            <firstName>${converaObj?.firstName}</firstName>
            <lastName>${converaObj?.lastName}</lastName>
            <address>${converaObj?.address}</address>
            <city>${converaObj?.city}</city>
            <state>${converaObj?.state}</state>
            <zip>${converaObj?.zipcode}</zip>
            <country>IND</country>
            <email>${converaObj?.email}</email>
            <customField></customField>
          </buyer>`;
      converaObj.services.forEach((service) => {
        dataInput += `<service>
            <id>${service.id}</id>
            <amount>${service.amountOwing}</amount>
          </service>`;
      });
      dataInput += `</paymentInformation>`;
      const widget = document.createElement("convera-payment");
      widget.id = "converaWidget";
      console.log(dataInput);
      widget.setAttribute("data-seller-info", dataInput);
      widget.setAttribute("data-locale", "en_US");
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
        containerRef.current.appendChild(widget);
      }
    };
    loadScript().then(() => {
      // Wait a tick to ensure web component is registered
      setTimeout(() => {
        createWidget();
      }, 100);
    }).catch((err) => {
      console.error("Failed to load Convera script", err);
    });
    return () => {
      // const scriptTag = document.querySelector('script[src*="sandbox-uat.spm.convera.com"]');
      // if (scriptTag) {
      //   document.body.removeChild(scriptTag);
      //   sessionStorage.removeItem('converaObj');
      // }
      const el = document.getElementById("converaWidget");
      if (el) el.remove();
    };
  }, []);

  return <div ref={containerRef} id="convera-container" />;
};

export default ConveraPayment;
